import { createContext } from 'react';
import {
  ProcessRequest,
} from 'API';
import { Updater } from 'use-immer';

type Props = [
  process: ProcessRequest | null,
  setProcess: Updater<ProcessRequest | null>,
];

const ProcessContext = createContext<Props>([
  null,
  () => { },
]);

export default ProcessContext;
